import * as d3 from 'd3';
import type { MonitorPalette } from '../chart/palette';
import { drawForward } from './layers/forward';
import { drawFrame, HISTORY_CLIP_ID } from './layers/frame';
import { drawGrid } from './layers/grid';
import { drawHistoryCells, drawHistoryLines } from './layers/history';
import {
    drawAxis,
    drawForwardStrip,
    drawMeetings,
    drawStrip,
} from './layers/marks';
import type { Model } from './model';
import type { Strings } from './strings';

export interface RenderOptions {
    strings: Strings;
    palette: MonitorPalette;
    historyLabel: string;
    highlightMeeting: number | null;
}

export function renderChart(
    el: SVGSVGElement,
    model: Model,
    opts: RenderOptions
): void {
    const { strings, palette, historyLabel, highlightMeeting } = opts;
    const svg = d3.select(el);
    svg.selectAll('*').remove();

    drawFrame(svg, model, strings, palette, historyLabel);
    drawGrid(svg.append('g'), model, palette);

    const hist = svg.append('g').attr('clip-path', `url(#${HISTORY_CLIP_ID})`);
    drawHistoryCells(hist.append('g'), model);
    drawMeetings(hist.append('g'), model, palette, highlightMeeting);
    drawHistoryLines(hist.append('g'), model, palette);
    drawStrip(hist.append('g'), model);

    drawForward(svg.append('g'), model, palette);
    drawForwardStrip(svg.append('g'), model);
    drawAxis(svg.append('g'), model, palette);
}
